// GLOBAL AFFIXES
export const FULFILLED = '_FULFILLED';
export const REJECTED = '_REJECTED';

// GLOBAL Entities
export const AUTOMATION_CONDITION = 'AUTOMATION_CONDITION';
export const BUCKET = 'BUCKET';
export const CALIBRATION = 'CALIBRATION';
export const DEPLOY = 'DEPLOY';
export const DEVICE = 'DEVICE';
export const EQUIPMENT = 'EQUIPMENT';
export const EQUIPMENT_ATTACHMENT = 'EQUIPMENT_ATTACHMENT';
export const EQUIPMENT_CATEGORY = 'EQUIPMENT_CATEGORY';
export const INDICATOR = 'INDICATOR';
export const INSTALLATION_PICTURE = 'INSTALLATION_PICTURE';
export const INSTALLATION_ZONE = 'INSTALLATION_ZONE';
export const MEASUREMENT = 'MEASUREMENT';
export const PROTOCOL = 'PROTOCOL';
export const READING = 'READING';
export const TEMPLATE = 'TEMPLATE';
export const USER = 'USER';
export const WISE_BOX = 'WISE_BOX';
export const WISE_BOX_DEVICE = 'WISE_BOX_DEVICE';

// bootstrap
export const BOOT = 'BOOT';
export const BOOTSTRAP = 'BOOTSTRAP';

// login failed
export const CLEAN_ALERT = 'CLEAN_ALERT';

// authentication
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

// ui
export const TOGGLE_MENU = 'TOGGLE_MENU';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

// buckets
export const CLEAR_BUCKETS = 'CLEAR_BUCKETS';
export const FETCH_BUCKETS = 'FETCH_BUCKETS';

// equipments
export const FETCH_EQUIPMENTS = 'FETCH_EQUIPMENTS';

// form initializers
export const INITIALIZE_FORM = 'INITIALIZE_FORM';
export const INITIALIZE_FORM_CLEAN_UP = 'INITIALIZE_FORM_CLEAN_UP';

// automation conditions
export const CLEAR_AUTOMATION_CONDITIONS = 'CLEAR_AUTOMATION_CONDITIONS';
export const FETCH_AUTOMATION_CONDITIONS = 'FETCH_AUTOMATION_CONDITIONS';

// sites
export const SITE = 'SITE';
export const LOAD_SITE = 'LOAD_SITE';
export const REFRESH_SITE = 'REFRESH_SITE';
export const REFRESH_SITE_STATUS = 'REFRESH_SITE_STATUS';
export const FETCH_SITE = 'FETCH_SITE';
export const FETCH_SITES = 'FETCH_SITES';
export const UPLOAD_BRIDGE_DEVICES = 'UPLOAD_BRIDGE_DEVICES';
export const UPLOAD_DEVICES = 'UPLOAD_DEVICES';
export const UPLOAD_DIGITAL_DEVICES = 'UPLOAD_DIGITAL_DEVICES';

// device tree
export const COLLAPSE_TREE = 'COLLAPSE_TREE';
export const EXPAND_TREE = 'EXPAND_TREE';
export const TOGGLE_SITES = 'TOGGLE_SITES';
export const TOGGLE_NODE = 'TOGGLE_NODE';
export const TOGGLE_PROBLEMS = 'TOGGLE_PROBLEMS';

// devices
export const CLEAR_DEVICES = 'CLEAR_DEVICES';
export const DELETE_DEVICE = 'DELETE_DEVICE';
export const DELETE_FUTURE = 'DELETE_FUTURE';
export const FETCH_DEVICES = 'FETCH_DEVICES';
export const REGENERATE_SEED_FILES = 'REGENERATE_SEED_FILES';

// device verifications
export const CLOSE_DEVICE_VERIFICATION_READING = 'CLOSE_DEVICE_VERIFICATION_READING';
export const DEVICE_VERIFICATION = 'DEVICE_VERIFICATION';
export const DEVICE_VERIFICATION_READING = 'DEVICE_VERIFICATION_READING';
export const FETCH_DEVICE_VERIFICATION = 'FETCH_DEVICE_VERIFICATION';
export const FETCH_DEVICE_VERIFICATIONS = 'FETCH_DEVICE_VERIFICATIONS';
export const FETCH_DEVICE_VERIFICATION_READINGS = 'FETCH_DEVICE_VERIFICATION_READINGS';
export const CLEAR_DEVICE_VERIFICATIONS = 'CLEAR_DEVICE_VERIFICATIONS';
export const CLEAR_DEVICE_VERIFICATION_READINGS = 'CLEAR_DEVICE_VERIFICATION_READINGS';

// device verification readings

// equipment categories
export const FETCH_EQUIPMENT_ATTACHMENTS = 'FETCH_EQUIPMENT_ATTACHMENTS';
export const FETCH_EQUIPMENT_CATEGORIES = 'FETCH_EQUIPMENT_CATEGORIES';

// indicators
export const FETCH_INDICATOR = 'FETCH_INDICATOR';
export const FETCH_INDICATORS = 'FETCH_INDICATORS';
export const CLEAR_INDICATORS = 'CLEAR_INDICATORS';

// installation Zones
export const FETCH_INSTALLATION_ZONES = 'FETCH_INSTALLATION_ZONES';
export const CLEAR_INSTALLATION_ZONES = 'CLEAR_INSTALLATION_ZONES';

// measurements
export const FETCH_MEASUREMENT = 'FETCH_MEASUREMENT';
export const FETCH_MEASUREMENTS = 'FETCH_MEASUREMENTS';
export const CLEAR_MEASUREMENTS = 'CLEAR_MEASUREMENTS';
export const UNLINK_MEASUREMENT = 'UNLINK_MEASUREMENT';

// protocols
export const FETCH_PROTOCOLS = 'FETCH_PROTOCOLS';

// readings
export const FETCH_READINGS = 'FETCH_READINGS';

// templates
export const FETCH_TEMPLATES = 'FETCH_TEMPLATES';

// users
export const FETCH_USERS = 'FETCH_USERS';

// wise_boxes
export const CLAIM_WISE_BOX = 'CLAIM_WISE_BOX';
export const FETCH_WISE_BOXES = 'FETCH_WISE_BOXES';
export const START_POOLING_WISE_BOXES = 'START_POOLING_WISE_BOXES';
export const STOP_POOLING_WISE_BOXES = 'STOP_POOLING_WISE_BOXES';
